export default function EditIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M8.06197 2.57159H3.15268C2.96333 2.56986 2.77554 2.60641 2.60027 2.67911C2.425 2.75181 2.26577 2.8592 2.13187 2.99501C1.99797 3.13082 1.8921 3.29233 1.82042 3.4701C1.74874 3.64788 1.71271 3.83835 1.71441 4.03041V13.9893C1.71525 14.1797 1.75316 14.3681 1.82597 14.5436C1.89878 14.7191 2.00506 14.8783 2.1387 15.012C2.27234 15.1458 2.43071 15.2514 2.60472 15.3229C2.77873 15.3944 2.96495 15.4303 3.15268 15.4286H12.4343C12.9237 15.4269 13.3926 15.2289 13.7387 14.8779C14.0848 14.5269 14.28 14.0513 14.2817 13.5549V9.86567"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M6 11.5713L14.5714 3.42847"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
			/>
		</svg>
	);
}
